export default __webpack_public_path__ + "static/982-5bdae7cbb7249fe93e061b7453befd01.gif";